import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { clearSessionExpiry, fetchSession, saveSessionExpiry, UnauthorizedError } from '../api/auth';

const SESSION_BOOTSTRAP_STALE_TIME_MS = 5 * 60 * 1000;

export function useProtectedSession(scopeKey: string | null) {
  const query = useQuery({
    queryKey: ['session', 'protected-bootstrap', scopeKey],
    queryFn: fetchSession,
    enabled: Boolean(scopeKey),
    retry: false,
    staleTime: SESSION_BOOTSTRAP_STALE_TIME_MS,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  useEffect(() => {
    if (scopeKey && query.data?.expiresAt) {
      saveSessionExpiry(scopeKey, query.data.expiresAt);
    }
  }, [query.data?.expiresAt, scopeKey]);

  useEffect(() => {
    if (scopeKey && query.error instanceof UnauthorizedError) {
      clearSessionExpiry(scopeKey);
    }
  }, [query.error, scopeKey]);

  return {
    ...query,
    isUnauthorized: query.error instanceof UnauthorizedError,
  };
}